import { Component } from '@angular/core';
import { DisplayableItemsComponent } from '../../../../../shared/components/displayable-content/displayable-items/displayable-items.component';
import { PrintProductTemplatesViewModel } from './print-product-templates-view-model';

@Component({
  selector: 'app-print-product-templates',
  templateUrl: './print-product-templates.component.html',
  styleUrls: ['./print-product-templates.component.scss'],
  providers: [PrintProductTemplatesViewModel],
  standalone: false
})
export class PrintProductTemplatesComponent extends DisplayableItemsComponent {
  constructor(public override viewModel: PrintProductTemplatesViewModel) {
    super(viewModel);
  }
}
